import component from './CardLayout';

export default component;
